/**
 * Audience 模块接口
 * 人群管理相关
 */

import { get, post } from '../request';
import type {
  Audience,
  GetAudienceListParams,
  CreateAudienceParams,
  EstimateAudienceParams,
  EstimateAudienceData,
  ExportAudienceData,
  PackageListResult,
  CreatePackageResult,
} from '../../type/audience-type';
import type { BasePageListData } from '../../type/common-type';

/**
 * 获取人群列表
 * GET /audiences
 */
export const getAudienceList = (params?: GetAudienceListParams) => {
  return get<BasePageListData<Audience>, GetAudienceListParams | undefined>('/audiences', params);
};

/**
 * 创建人群
 * POST /audiences
 */
export const createAudience = (params: CreateAudienceParams) => {
  return post<Audience>('/audiences', params);
};

/**
 * 预估人群覆盖人数
 * POST /audiences/estimate
 */
export const estimateAudience = (params: EstimateAudienceParams) => {
  return post<EstimateAudienceData>('/audiences/estimate', params);
};

/**
 * @deprecated 请使用 generatePackage
 * 触发生成 CSV 导出文件
 * POST /audiences/{id}/export
 */
export const exportAudience = (audienceKey: string) => {
  return post<ExportAudienceData>(`/audiences/${audienceKey}/export`);
};

/**
 * 生成人群包（异步）
 * POST /audiences/{id}/packages
 */
export const generatePackage = (audienceKey: string) => {
  return post<CreatePackageResult>(`/audiences/${audienceKey}/packages`);
};

/**
 * 获取人群包记录列表
 * GET /audiences/{id}/packages
 */
export const getPackageList = (audienceKey: string) => {
  return get<PackageListResult>(`/audiences/${audienceKey}/packages`);
};
